export default "__VITE_ASSET__535ea956__"